import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import {
  fetchPaymentType,
  addPaymentType,
  deletePaymentType,
  updatePaymentType
} from "../../actions/paymentType";

import moment from 'moment';
const $ = window.$;
class TypeOfPayments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingDelete: false,
      paymentTypes: [],
      newPaymentType: "",
      editId: "",
      editType: ""
    };
  }
  changeVal = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  addPaymentType = e => {
    e.preventDefault();
    if (this.state.newPaymentType.length > 0) {
      const data = {
        payment_type: this.state.newPaymentType
      };
      this.props.addPaymentType(data);
    }
  };
  toggleEdit = (id, type) => {
    if (this.state.editId === id) {
      this.setState({ editId: "" });
      return true;
    }

    this.setState({ editId: id, editType: type });
  };

  cancelEdit = () => {
    this.setState({ editId: "", editType: "" });
  };

  saveEdit = (e, type) => {
    e.preventDefault();
    if (this.state.editType.length <= 0) return true;
    if (this.state.editType === type) {
      this.setState({ loading: false, editId: "", editType: "" });
      return true;
    }
    const data = {
      payment_type: this.state.editType
    };
    this.props.updatePaymentType(this.state.editId, data);
  };

  openConfirmDeleteModal = id => {
    this.setState({ selectedId: id });
    $("#confirm_payment_type_delete_modal").modal("show");
  };

  deletePaymentType = () => {
    this.setState({ loadingDelete: true });
    if (this.state.selectedId) {
      this.props.deletePaymentType(this.state.selectedId);
    } else {
      NotificationManager.warning("This type not available.");
      this.setState({ loadingDelete: false });
    }
  };
  componentDidMount() {
    this.props.fetchPaymentType();
  }
  componentWillReceiveProps = nextProps => {
    if (this.props.data.newPaymentType !== nextProps.data.newPaymentType) {
      this.setState({ loading: false, newPaymentType: "" });
      this.props.fetchPaymentType();
      NotificationManager.success("Type Added Successfully");
    }

    if (
      this.props.data.updatedPaymentType !==
        nextProps.data.updatedPaymentType &&
      nextProps.data.updatedPaymentType.payment_type
    ) {
      this.setState({ loading: false, editId: "", editType: "" });
      this.props.fetchPaymentType();
      NotificationManager.success("Type Updated Successfully");
    }

    if (this.props.data.selectedToDelete !== nextProps.data.selectedToDelete) {
      $("#confirm_payment_type_delete_modal").modal("hide");
      this.setState({ loadingDelete: false, selectedId: "" });
      this.props.fetchPaymentType();
      NotificationManager.success("Type Deleted Successfully");
    }
    if (
      this.props.data.newPaymentTypeError !== nextProps.data.newPaymentTypeError
    ) {
      this.setState({ loading: false, newPaymentType: "" });
      NotificationManager.error("Faild to add new type.");
    }

    if (
      this.props.data.updatedPaymentTypeError !==
      nextProps.data.updatedPaymentTypeError
    ) {
      this.setState({ loading: false, editId: "", editType: "" });
      NotificationManager.error("Faild to update type.");
    }

    if (
      this.props.data.deletePaymentTypeError !==
      nextProps.data.deletePaymentTypeError
    ) {
      $("#confirm_payment_type_delete_modal").modal("hide");
      this.setState({ loadingDelete: false, selectedId: "" });
      NotificationManager.error("Failed to delete type.");
    }

    if (this.props.data.paymentTypes !== nextProps.data.paymentTypes) {
      this.setState({ paymentTypes: nextProps.data.paymentTypes });
    }
  };
  render() {
    const { petShop } = this.props;
    return (
      <div>
        <div className="m-portlet__body">
          <div className="m-form__section m-form__section--first row">
            <div
              className="col-md-12"
              style={{ alignItems: "center", display: "flex" }}
            >
              <div className="m-widget4 m-width-100-perc">
                {this.state.paymentTypes.map(t => (
                  <div key={t.id} className="m-widget4__item">
                    {this.state.editId === t.id ? (
                      <div
                        className="col-md-12"
                        style={{ display: "inline-flex" }}
                      >
                        <input
                          type="text"
                          name="editType"
                          onChange={this.changeVal}
                          value={this.state.editType}
                          className="form-control m-input mr-2"
                          placeholder=""
                        />
                        <button
                          onClick={e => this.saveEdit(e, t.payment_type)}
                          className="btn btn-link btn-link-no-deco m-widget4__icon mr-2"
                        >
                          <i className="la la-check"></i>
                        </button>
                        <button
                          onClick={this.cancelEdit}
                          className="btn btn-link btn-link-no-deco m-widget4__icon"
                        >
                          <i className="la la-close"></i>
                        </button>
                      </div>
                    ) : (
                      <React.Fragment>
                        <div className="m-widget4__img m-widget4__img--icon">
                          <i className="la la-check"></i>
                        </div>
                        <div className="m-widget4__info">
                          <span className="m-widget4__text">
                            {t.payment_type}
                          </span>
                        </div>
                        <div className="m-widget4__ext">
                          <button
                            onClick={() =>
                              this.toggleEdit(t.id, t.payment_type)
                            }
                            className="btn btn-link btn-link-no-deco m-widget4__icon"
                          >
                            <i className="la la-edit"></i>
                          </button>
                        </div>
                        <div className="m-widget4__ext">
                          <button
                            onClick={e => {
                              e.preventDefault();
                              this.openConfirmDeleteModal(t.id);
                            }}
                            className="btn btn-link btn-link-no-deco m-widget4__icon"
                          >
                            <i className="la la-trash-o"></i>
                          </button>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="m-portlet__foot m-portlet__foot--fit">
          <div className="m-form__actions m--align-right">
            <input
              type="text"
              name="newPaymentType"
              onChange={this.changeVal}
              value={this.state.newPaymentType}
              className="form-control m-input mr-2"
              placeholder="Add new payment type"
            />
            <button
              onClick={this.addPaymentType}
              className="btn btn-primary m-btn m-btn--icon m-btn--pill mt-4"
            >
              <span>
                <i className="la la-save"></i>
                <span>Save</span>
              </span>
            </button>
          </div>
        </div>
        <div
          className="modal fade"
          id="confirm_payment_type_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete term
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  If you choose to confirm this type will no longer available.
                  Would you like to confirm?
                </p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDelete == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deletePaymentType()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                  <div className="center-row">
                    <Loader size={50} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  user: state.cognito.user,
  petShop: state.petShopReducer.currentPetshop,
  data: state.paymentTypeReducer
});
const mapDispatchToProps = dispatch => ({
  fetchPaymentType: () => {
    dispatch(fetchPaymentType());
  },
  addPaymentType: data => {
    dispatch(addPaymentType(data));
  },
  deletePaymentType: id => {
    dispatch(deletePaymentType(id));
  },
  updatePaymentType: (id, data) => {
    dispatch(updatePaymentType(id, data));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TypeOfPayments)
);
